const API = process.env.REACT_APP_API || 'http://localhost:3001/api';

function headers() {
  const h = { 'Content-Type': 'application/json' };
  const token = localStorage.getItem('token');
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
}

export async function login(email, senha) {
  const res = await fetch(`${API}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, senha }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error);
  localStorage.setItem('token', data.token);
  localStorage.setItem('usuario', JSON.stringify(data.usuario));
  return data;
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
}

export function getUsuario() {
  const u = localStorage.getItem('usuario');
  return u ? JSON.parse(u) : null;
}

export function isAuthenticated() {
  return !!localStorage.getItem('token');
}

export async function getProdutos() {
  const res = await fetch(`${API}/produtos`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar produtos');
  return res.json();
}

export async function createProduto(data) {
  const res = await fetch(`${API}/produtos`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao criar produto');
  return res.json();
}

export async function updateProduto(id, data) {
  const res = await fetch(`${API}/produtos/${id}`, {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao atualizar produto');
  return res.json();
}

export async function deleteProduto(id) {
  const res = await fetch(`${API}/produtos/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) throw new Error('Erro ao remover produto');
  return res.json();
}

export async function getMovimentacoes() {
  const res = await fetch(`${API}/movimentacoes`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar movimentações');
  return res.json();
}

export async function addEntrada(produto_id, quantidade) {
  const res = await fetch(`${API}/movimentacoes/entrada`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ produto_id, quantidade }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error);
  }
  return res.json();
}

export async function addSaida(produto_id, quantidade, cliente_id) {
  const body = { produto_id, quantidade };
  if (cliente_id) body.cliente_id = cliente_id;
  const res = await fetch(`${API}/movimentacoes/saida`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error);
  }
  return res.json();
}

export async function getResumo(mes, ano) {
  const params = new URLSearchParams();
  if (mes) params.set('mes', mes);
  if (ano) params.set('ano', ano);
  const qs = params.toString();
  const res = await fetch(`${API}/relatorios/resumo${qs ? '?' + qs : ''}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar resumo');
  return res.json();
}

export async function getRelatorioPeriodo(inicio, fim) {
  const params = new URLSearchParams();
  if (inicio) params.set('inicio', inicio);
  if (fim) params.set('fim', fim);
  const res = await fetch(`${API}/relatorios/periodo?${params}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar relatório');
  return res.json();
}

export async function getCustos() {
  const res = await fetch(`${API}/custos`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar custos');
  return res.json();
}

export async function createCusto(data) {
  const res = await fetch(`${API}/custos`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao criar custo');
  return res.json();
}

export async function deleteCusto(id) {
  const res = await fetch(`${API}/custos/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) throw new Error('Erro ao remover custo');
  return res.json();
}

export async function getClientes() {
  const res = await fetch(`${API}/clientes`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar clientes');
  return res.json();
}

export async function createCliente(data) {
  const res = await fetch(`${API}/clientes`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao criar cliente');
  return res.json();
}

export async function deleteCliente(id) {
  const res = await fetch(`${API}/clientes/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) throw new Error('Erro ao remover cliente');
  return res.json();
}

export async function criarPedido(data) {
  const res = await fetch(`${API}/pedidos`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error);
  }
  return res.json();
}

export async function getPedido(id) {
  const res = await fetch(`${API}/pedidos/${id}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar pedido');
  return res.json();
}
